import { Shark, Utils } from "shark-mvc";

import templateContent from "./charged-vehicle.html";
import { vehicleManager } from "../../_shark_jaws/managers/vehicleManager";
import { vehicleActivityManager } from "../../_shark_jaws/managers/vehicleActivityManager";

import { vehicleReturnView } from "../../_shark_jaws/views/vehicleReturnView";

var chargedVehicleComponent = Shark.createJaw("chargedVehicleComponent");
chargedVehicleComponent.templateContent = templateContent;

chargedVehicleComponent.addMethod("beforeLoad", function(){
	const vehicleList = Shark.get("vehicleList");
	if (vehicleList.length === 0) {
		vehicleManager.getList();
	}

	const chargedVehicleList = Shark.get("chargedVehicleList");
	if (chargedVehicleList.length === 0) {
		vehicleActivityManager.chargedToDriver();
	}

});

chargedVehicleComponent.addMethod("beforeRender", function () {
	const chargedVehicleList = Shark.get("chargedVehicleList");
	chargedVehicleList.forEach(vehicleActivity => {
		vehicleActivity.vehicleData = Utils.safp(Shark.get("vehicleList"), "id", vehicleActivity.vehicleId);
	});
});

chargedVehicleComponent.addMethod("init", function () {
	Shark.set({
		vehicleList: Shark.get("vehicleList") || [],
		chargedVehicleList: Shark.get("chargedVehicleList") || []
	});
});

chargedVehicleComponent.addMethod("vehicleActivityManager_chargedToDriverListChangedHandler", function () {
	Shark.render();
});

chargedVehicleComponent.addMethod("vehicleActivityManager_savedHandler", function () {
	vehicleActivityManager.chargedToDriver();
});

chargedVehicleComponent.addMethod("vehicleManager_listChangedHandler", function () {
	Shark.render();
});

chargedVehicleComponent.addMethod("selectedVehicleActivity_clickHandler", function (event, data) {
	const selectedVehicleActivity = Utils.safp(Shark.get("chargedVehicleList"), "id", data.id);
	
	selectedVehicleActivity.__vehicleName = selectedVehicleActivity.vehicleData.name;
	Shark.set({selectedVehicleActivity});
	
	console.log({"selectedVehicleActivity_clickHandler":selectedVehicleActivity});
	Shark.openPage(vehicleReturnView);
});

Shark.registerComponent(chargedVehicleComponent);

export { chargedVehicleComponent };
